import React from "react"

import { Link } from "gatsby"

import { ArrowUpRight } from "akar-icons"
import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"

import "./NewestCollections.scss"

const NewestCollections = ({ section }) => {
  const url = section.image?.url
  const altText = section.image?.alt

  return (
    <section className="newest-collections">
      <section className="newest-collections__wrapper">
        <Fade>
          <div
            className="newest-collections__wrapper__description"
            style={
              section.backgroundColor && {
                backgroundColor: section.backgroundColor,
              }
            }
          >
            <div
              className="newest-collections__wrapper__description__text"
              style={
                section.textColor
                  ? {
                      color: section.textColor,
                    }
                  : null
              }
            >
              <p className="newest-collections__wrapper__description__text__title">
                {section.title || "Lorem Ipsum Title"}
              </p>
              <p className="newest-collections__wrapper__description__text__body">
                {section.description ||
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
              </p>
              <button
                className="newest-collections__wrapper__description__text__btn"
                style={
                  section.buttonBackgroundColor
                    ? {
                        backgroundColor: section.buttonBackgroundColor,
                      }
                    : null
                }
              >
                <Link
                  to={`/${section.buttonLink}`}
                  style={
                    section.buttonTextColor
                      ? {
                          color: section.buttonTextColor,
                        }
                      : null
                  }
                >
                  {section.buttonText || "Button"}&nbsp;
                  <ArrowUpRight size={16} />
                </Link>
              </button>
            </div>
          </div>
          <div className="newest-collections__wrapper__image">
            <img
              src={
                url ||
                "https://images.unsplash.com/photo-1619208382871-96f4d45bc840?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTl8fG1lbiUyMGZhc2hpb258ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60"
              }
              alt={altText}
              loading="lazy"
            />
          </div>
        </Fade>
      </section>
    </section>
  )
}

NewestCollections.propTypes = {
  section: PropTypes.object.isRequired,
}

export default NewestCollections
